import { render, staticRenderFns } from "./FormItemExtendList.vue?vue&type=template&id=6403a0ce&scoped=true"
import script from "./FormItemExtendList.vue?vue&type=script&lang=js"
export * from "./FormItemExtendList.vue?vue&type=script&lang=js"
import style0 from "./FormItemExtendList.vue?vue&type=style&index=0&id=6403a0ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6403a0ce",
  null
  
)

export default component.exports